import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteSensorExclusionMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteSensorExclusionMutationPage = { readonly __typename?: 'RootMutationType', readonly deleteSensorExclusion: boolean };


export const DeleteSensorExclusionDocument = gql`
    mutation DeleteSensorExclusion($id: ID!) {
  deleteSensorExclusion(id: $id)
}
    `;
export type DeleteSensorExclusionMutationFn = Apollo.MutationFunction<DeleteSensorExclusionMutationPage, DeleteSensorExclusionMutationVariables>;

/**
 * __useDeleteSensorExclusionMutation__
 *
 * To run a mutation, you first call `useDeleteSensorExclusionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSensorExclusionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSensorExclusionMutation, { data, loading, error }] = useDeleteSensorExclusionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSensorExclusionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSensorExclusionMutationPage, DeleteSensorExclusionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSensorExclusionMutationPage, DeleteSensorExclusionMutationVariables>(DeleteSensorExclusionDocument, options);
      }
export type DeleteSensorExclusionMutationHookResult = ReturnType<typeof useDeleteSensorExclusionMutation>;
export type DeleteSensorExclusionMutationResult = Apollo.MutationResult<DeleteSensorExclusionMutationPage>;
export type DeleteSensorExclusionMutationOptions = Apollo.BaseMutationOptions<DeleteSensorExclusionMutationPage, DeleteSensorExclusionMutationVariables>;